import { CurrencyPipe } from '@angular/common';
import { inject, Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'opaCurrency',
  standalone: true,
})
export class OpaCurrencyPipe implements PipeTransform {
  private readonly currencyPipe = inject(CurrencyPipe);

  /**
   * similar to CurrencyPipe https://github.com/angular/angular/blob/04101e69ff5e8d9cec527dbb7256ad2f896a55b5/packages/common/src/pipes/number_pipe.ts#L220,
   * with special output formatting
   */
  transform(
    value: number | string | null | undefined,
    decimalSeparator: 'dot' | 'comma' | null | undefined = 'dot',
    leadingPlus: boolean | null | undefined = false,
  ): string | null {
    let currency = this.currencyPipe.transform(value);
    if (currency == null) return currency;

    decimalSeparator ??= 'dot';
    leadingPlus ??= false;
    currency = this.formatDecimalSeparator(currency, decimalSeparator);
    currency = this.formatLeadingPlus(currency, leadingPlus);
    return currency;
  }

  private formatDecimalSeparator(currency: string, decimalSeparator: 'dot' | 'comma'): string {
    const dotIsLast = currency.lastIndexOf('.') >= currency.lastIndexOf(',');
    if (decimalSeparator === 'dot' && dotIsLast) return currency;

    const formatted = currency
      .split('')
      .map((el) => {
        if (el === ',') return '.';
        if (el === '.') return ',';
        return el;
      })
      .join('');
    return formatted;
  }

  private formatLeadingPlus(currency: string, leadingPlus: boolean): string {
    if (!leadingPlus) return currency;

    const number = Number(currency.replace(/[^-.0-9]/g, ''));
    const formatted = number >= 0 ? `+${currency}` : currency;
    return formatted;
  }
}
